import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=0cd8439e&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Notification.vue?vue&type=style&index=0&id=0cd8439e&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./Notification.vue?vue&type=style&index=1&id=0cd8439e&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0cd8439e",
  "b70aa2c8"
  
)

export default component.exports